(function () {
  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([a-zA-Z0-9_-]+)/);
    return match ? match[1] : null;
  }

  function findAddToCartAnchor() {
    return (
      document.querySelector('.product-form__buttons') ||
      document.querySelector('[data-type="add-to-cart-form"]') ||
      document.querySelector('product-form form') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function formatTime(ms) {
    var totalSeconds = Math.max(0, Math.floor(ms / 1000));
    var m = Math.floor(totalSeconds / 60);
    var s = totalSeconds % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }

  function startCountdown(key, clockEl, onExpire) {
    var duration = 5 * 60 * 1000;
    var now = Date.now();
    var expiry = parseInt(localStorage.getItem(key), 10);
    if (!expiry || isNaN(expiry) || expiry < now) {
      expiry = now + duration;
      try { localStorage.setItem(key, String(expiry)); } catch (e) {}
    }
    var timer = setInterval(function () {
      var remaining = expiry - Date.now();
      if (remaining <= 0) {
        clearInterval(timer);
        if (onExpire) onExpire();
        return;
      }
      if (clockEl) clockEl.textContent = formatTime(remaining);
    }, 1000);
    // set immediately too, so it doesn't show 05:00 for a second
    if (clockEl) clockEl.textContent = formatTime(expiry - Date.now());
    return timer;
  }

  // --- Product page: low-stock banner above "Add to cart" ---
  function initProductPage() {
    var handle = getProductHandle();
    if (!handle) return;

    fetch('/products/' + handle + '.js', { credentials: 'omit', cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data) return;
        var variant = data.variants && data.variants.find(function (v) { return v.available; });
        if (!variant) return;

        var anchor = findAddToCartAnchor();
        if (!anchor || document.getElementById('najcior-reserve-timer')) return;

        var lowStock = data.variants.filter(function (v) { return v.available; }).length <= 1
          && data.variants.length <= 2;
        if (!lowStock) return;

        var banner = document.createElement('div');
        banner.id = 'najcior-reserve-timer';
        banner.style.cssText =
          'margin:0 0 14px 0;padding:10px 14px;background:#fff4e5;border:1px solid #f0c36d;' +
          'border-radius:8px;font-size:14px;line-height:1.4;color:#7a4a00;display:flex;' +
          'align-items:center;gap:8px;';
        banner.innerHTML =
          '<span aria-hidden="true">🔥</span>' +
          '<span>Ostatnia sztuka! Zarezerwowana dla Ciebie jeszcze: ' +
          '<strong id="najcior-reserve-timer-clock">05:00</strong></span>';
        anchor.parentNode.insertBefore(banner, anchor);

        startCountdown(
          'najcior_reserve_' + handle,
          document.getElementById('najcior-reserve-timer-clock'),
          function () { banner.style.display = 'none'; }
        );
      })
      .catch(function () {});
  }

  // --- Cart / cart drawer: reservation notice next to the free-shipping progress indicator ---

  // Finds the element that shows the "free shipping remaining" progress text,
  // by looking for text mentioning "wysyłki" / "dostawy" (shipping/delivery).
  function findFreeShippingEl(root) {
    var candidates = root.querySelectorAll(
      '[class*="shipping"], [class*="free-shipping"], [class*="progress"], [data-free-shipping], [class*="wysylk"]'
    );
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      var txt = (el.textContent || '').toLowerCase();
      if (txt.indexOf('wysy') !== -1 || txt.indexOf('dostaw') !== -1) return el;
    }
    // fallback: scan small text nodes for the phrase directly
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue.toLowerCase();
      if (t.indexOf('wysy') !== -1 || t.indexOf('dostaw') !== -1) {
        var el2 = node.parentElement;
        // climb up a couple levels to get a reasonable block container
        return (el2 && el2.closest('div,p,li')) || el2;
      }
    }
    return null;
  }

  var CART_NOTICE_ID = 'najcior-cart-reserve-notice';
  var CART_NOTICE_CLOCK_ID = 'najcior-cart-reserve-clock';

  function buildReserveNotice() {
    var notice = document.createElement('div');
    notice.id = CART_NOTICE_ID;
    notice.style.cssText =
      'margin:8px 0;padding:10px 12px;background:#fff4e5;border:2px solid #e8a33d;' +
      'border-radius:8px;font-size:13px;line-height:1.4;color:#7a4a00;display:flex;' +
      'align-items:center;gap:6px;font-weight:600;box-shadow:0 1px 4px rgba(232,163,61,0.35);';
    notice.innerHTML =
      '<span aria-hidden="true" style="font-size:16px;">⏳</span>' +
      '<span>Masz ten produkt zarezerwowany jeszcze przez ' +
      '<strong id="' + CART_NOTICE_CLOCK_ID + '">05:00</strong> — potem oferta wygasa.</span>';
    return notice;
  }

  function placeCartReserveNotice(root, cartToken) {
    // Only one notice on the page at a time — some themes match several
    // nested wrapper elements against the same drawer selector, which would
    // otherwise insert one copy per wrapper.
    if (document.getElementById(CART_NOTICE_ID)) return;

    var notice = buildReserveNotice();

    var shippingEl = findFreeShippingEl(root);
    if (shippingEl && shippingEl.parentNode) {
      // Insert after the shipping message AND its progress bar (if the bar
      // is a separate following sibling), so the message + bar stay paired
      // and our notice doesn't wedge itself in between them.
      var insertAfter = shippingEl;
      var next = shippingEl.nextElementSibling;
      if (next && /progress-?bar/i.test(next.className || '')) {
        insertAfter = next;
      }
      insertAfter.parentNode.insertBefore(notice, insertAfter.nextSibling);
    } else {
      // fallback: put it near the top of the cart items area, or just prepend to root
      var itemsEl = root.querySelector('[class*="cart-items"], [class*="cart__items"], form[action*="/cart"]');
      if (itemsEl) {
        itemsEl.parentNode.insertBefore(notice, itemsEl);
      } else {
        root.prepend(notice);
      }
    }

    startCountdown(
      'najcior_cart_reserve_' + (cartToken || 'default'),
      document.getElementById(CART_NOTICE_CLOCK_ID),
      function () { notice.style.display = 'none'; }
    );
  }

  // Tries the main cart page and any cart-drawer markup present in the DOM.
  function initCartReserveNotice() {
    // Cart state is per-session (cookie-based), so this fetch must send
    // credentials — unlike the anonymous product-availability check above.
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (!data || !data.item_count) return;
        if (document.getElementById(CART_NOTICE_ID)) return;

        // On the actual /cart page, use the visible page content — the
        // cart-drawer element still exists in the DOM there (hidden,
        // off-screen) and must not be preferred over the visible page.
        // Everywhere else, use the drawer.
        var isCartPage = window.location.pathname.indexOf('/cart') !== -1;
        var target = isCartPage
          ? (document.querySelector('main, #MainContent, [class*="cart-page"], [class*="cart__page"]') ||
             document.querySelector('cart-drawer'))
          : (document.querySelector('cart-drawer') ||
             document.querySelector('[id*="cart-drawer"], [class*="mini-cart"], [class*="cart-drawer"]'));

        // Skip a target that's hidden or off-screen (e.g. an unopened drawer
        // duplicated for another breakpoint) — wait for a visible one instead.
        if (target) {
          var rect = target.getBoundingClientRect();
          var style = getComputedStyle(target);
          var isVisible = style.visibility !== 'hidden' && style.display !== 'none' &&
            rect.width > 0 && rect.height > 0;
          if (isVisible) placeCartReserveNotice(target, data.token);
        }
      })
      .catch(function () {});
  }

  // --- Site-wide: force Polish "Dodaj do koszyka" label, remove PayPal express button ---
  function fixButtonsIn(root) {
    root = root || document;

    // Replace literal "Add to cart" text with the Polish label.
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var node;
    var toFix = [];
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.trim() === 'Add to cart') {
        toFix.push(node);
      }
    }
    toFix.forEach(function (n) { n.nodeValue = n.nodeValue.replace('Add to cart', 'Dodaj do koszyka'); });

    // Also cover button/input value attributes (some themes render it as a value=).
    root.querySelectorAll('button, input[type="submit"]').forEach(function (btn) {
      if (btn.value && btn.value.trim() === 'Add to cart') btn.value = 'Dodaj do koszyka';
    });

    // Hide the PayPal express-checkout button (Shopify dynamic checkout), leave Shop Pay / Google Pay.
    root.querySelectorAll('iframe[title], iframe[aria-label]').forEach(function (iframe) {
      var label = (iframe.title || iframe.getAttribute('aria-label') || '');
      if (label.toLowerCase().indexOf('paypal') !== -1) {
        var wrapper = iframe.closest('.shopify-payment-button__button, .shopify-payment-button, [class*="payment-button"]') || iframe.parentElement;
        if (wrapper) wrapper.style.display = 'none';
      }
    });
  }

  function initButtonFixes() {
    fixButtonsIn(document);
    var reserveNoticeThrottle = null;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) fixButtonsIn(n);
        });
      });
      // Re-check cart reserve notice placement whenever DOM changes (cart drawer
      // content is often injected after an add-to-cart AJAX call), throttled so a
      // burst of mutations doesn't trigger a fetch storm.
      if (reserveNoticeThrottle) return;
      reserveNoticeThrottle = setTimeout(function () {
        reserveNoticeThrottle = null;
        initCartReserveNotice();
        // Product sections on this theme can hydrate/re-render after our first
        // pass, wiping out or pre-empting the low-stock banner — keep retrying
        // (initProductPage no-ops once the banner already exists).
        if (window.location.pathname.includes('/products/')) initProductPage();
      }, 500);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    if (window.location.pathname.includes('/products/')) {
      initProductPage();
    }
    initCartReserveNotice();
    initButtonFixes();

    // Belt-and-braces: some sections on this theme hydrate/re-render shortly
    // after first paint, which can wipe out or pre-empt elements we inserted
    // before they existed. Poll for a short window after load as a fallback
    // to the MutationObserver-based retries above (all the init* functions
    // no-op once their element already exists).
    var pollCount = 0;
    var pollId = setInterval(function () {
      pollCount++;
      if (window.location.pathname.includes('/products/')) initProductPage();
      initCartReserveNotice();
      if (pollCount >= 10) clearInterval(pollId);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
